export const FileAlreadyExistModal: string = 'FileAlreadyExistModal';
